import { ButtonProps } from "antd";
import { FC, ReactNode } from "react";

import { StyledButton } from "./Styled";

export type ButtonVariant = "neutral" | "success" | "error";

interface OutlineIconButtonProps extends Omit<ButtonProps, "variant"> {
    icon: ReactNode;
    variant?: ButtonVariant;
    dimension?: number;
    border?: boolean;
}

export const OutlineIconButton: FC<OutlineIconButtonProps> = ({
    icon,
    variant = "neutral",
    border = true,
    dimension = 54,
    ...rest
}) => {
    return (
        <StyledButton
            type="text"
            icon={icon}
            $type={variant}
            $border={border}
            $dimension={dimension}
            {...rest}
        />
    );
};
